export const urgency = Object.freeze({
  URGENT: 'URGENT',
  PLAN: 'PLAN',
  NONE: 'NONE',
  HOLD: 'HOLD',
});

export const HAVE_RECOMMENDATIONS = 'Recommendation';
export const NO_RECOMMENDATIONS = 'No_Recommendation';
export const ACTIVITY_PRESENT = 'Activity_present';
export const NO_ACTIVITY_PRESENT = 'No_activity_present';
export const BOOKMARKED = 'Bookmarked';
export const NOT_BOOKMARKED = 'Not_Bookmarked';
export const FIELD = 'Field Visit';
export const REMOTE = 'Remote Fix';

export const resolutionTypeTexts = Object.freeze({
  none: 'None',
  fieldVisit: 'Field Visit',
  remoteFix: 'Remote Fix',
  both: 'Both Remote & Field visit',
});

export const resolutionTypeFilters = Object.freeze({
  field: 'Field',
  remote: 'Remote',
  both: 'RemoteFieldBoth',
});

export const resolutionTypeTextsWithResponseIds = Object.freeze({
  FLD: { id: 'Field Visit', label: 'Field_Visit' },
  REM: { id: 'Remote Fix', label: 'Remote_Fix' },
  NONE: { id: 'None', label: 'None' },
});

export const workOrderStatusIdMapping = Object.freeze({
  completed: 'COMPLETED',
  inProgress: 'INPROGRESS',
  inPro: 'INPRO',
});

export const workOrderStatusDnMapping = Object.freeze({
  completed: 'Completed',
  inProgress: 'In Progress',
  inPro: 'In Progress Update',
});

export const workOrderStatusIdToDnMapping = Object.freeze({
  COMPLETED: 'Completed',
  INPROGRESS: 'In Progress',
  INPRO: 'In Progress',
});

export const workOrderStatusLabelsMapping = Object.freeze({
  Completed: 'Completed',
  'In Progress': 'In_Progress',
});

export const workOrderStatusLabelsMappingUpperCase = Object.freeze({
  Completed: 'COMPLETED',
  'In Progress': 'IN_PROGRESS',
});

export const recommedationIdMapping = Object.freeze({
  confirm: 'CONFIRM',
  none: 'NONE',
});

export const partsIdMapping = Object.freeze({
  planned: 'PLAN',
  replaced: 'REPL',
});

export const paiFeedbackAssetCount = 2;

export const sectionNameListMapping = {
  all: 'all',
  sources: 'fbSrc',
  workstatus: 'workSts',
  noIssueExists: 'noIssueExists',
  recommendations: 'userRecomms',
  comments: 'userComments',
  parts: 'parts',
};

export const mapSectionWithAPIEndpoint = {
  sources: '/source',
  comments: '/comments',
  workstatus: '/workstatus',
  recommendations: '/recommendations',
  parts: '/parts',
  noIssueExists: '',
};

export const benefitTypesPosMapping = Object.freeze({
  CMFRT: 1,
  UPT: 2,
  'H&S': 3,
  RFS: 4,
  MAINTC: 5,
  MAINTP: 6,
  EE: 7,
  CONN: 8,
  DCONN: 9,
  CNTRL_PERF: 10,
  PERF: 11,
});

export const benefitTypes = Object.freeze({
  CMFRT: 'CMFRT',
  UPT: 'UPT',
  'H&S': 'H&S',
  RFS: 'RFS',
  MAINTC: 'MAINTC',
  MAINTP: 'MAINTP',
  EE: 'EE',
  CONN: 'CONN',
  DCONN: 'DCONN',
  CNTRL_PERF: 'CNTRL_PERF',
});

export const RESOLUTION_TYPE_MAP = {
  REM: {
    siteDetailfilterValue: ['Remote Fix', 'Both Remote & Field visit'],
    siteSumFilterValue: ['Remote', 'RemoteFieldBoth'],
  },
  FLD: {
    siteDetailfilterValue: ['Field Visit', 'Both Remote & Field visit'],
    siteSumFilterValue: ['Field', 'RemoteFieldBoth'],
  },
};

export const CONFIRM_TEXT = 'confirm';

export const defaultReason = [
  { src: { id: 'PROACT-REQ', dn: 'Proactive Request' }, srcId: '' },
];

export const todoListActivitesData = [
  { id: 'PROACT-REQ', dn: 'Proactive request', displayOrder: 1 },
  { id: 'CUST-SUPPORT', dn: 'Customer support', displayOrder: 2 },
  { id: 'FIELD-VISIT', dn: 'Field visit', displayOrder: 5 },
];

export const REC_BY_AI = 'AI';

export const workSts = {
  INPROGRESS: 'INPRO',
  COMPLETED: 'COMPLETED',
};

export const ppRegexFilter = /^__D/;

export const recommendationFeedbackStatus = Object.freeze({
  confirm: 'CONFIRM',
  none: 'NONE',
});

export const feedbackMaxLimitValue = 'Too Many Entries';
